module.exports = __webpack_public_path__ + "img/图片4.da6afe3e.png";